import { useQueryClient } from "@tanstack/react-query";

import {
  type Journal,
  journalSchema,
} from "../../../lib/types/schema/journalSchema";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";
import { keyJournal, keyJournals } from "./keyJournals";

export const useRequestJournalMutations = () => {
  const queryClient = useQueryClient();
  return {
    mutationPost: useRequestMutation<
      typeof journalSchema,
      { journal: Journal }
    >({
      mutationFnRequestProps: ({ journal }) => ({
        method: "POST",
        urlBackendPath: "/journals",
        schema: journalSchema,
        body: JSON.stringify(journal),
      }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [keyJournals()] });
      },
    }),
    mutationPut: useRequestMutation<
      typeof journalSchema,
      { id: number; journal: Journal }
    >({
      mutationFnRequestProps: ({ id, journal }) => ({
        method: "PUT",
        urlBackendPath: `/journals/${journal.sync_uuid}`,
        schema: journalSchema,
        body: JSON.stringify(journal),
      }),
      onSuccess: (journal) => {
        queryClient.invalidateQueries({
          queryKey: [keyJournal({ id: journal.id })],
        });
        queryClient.invalidateQueries({ queryKey: [keyJournals()] });
      },
    }),
    mutationDelete: useRequestMutation<typeof journalSchema, { uuid: string }>({
      mutationFnRequestProps: ({ uuid }) => ({
        method: "DELETE",
        urlBackendPath: `/journals/${uuid}`,
        schema: journalSchema,
      }),
      onSuccess: (journal) => {
        queryClient.invalidateQueries({
          queryKey: [keyJournal({ id: journal.id })],
        });
        queryClient.invalidateQueries({ queryKey: [keyJournals()] });
      },
    }),
  };
};
